
<template>
  <div v-loading="loading" class="admin" />
</template>
<script>
import { setToken } from '@/utils/auth';
import { login_token } from '@/api/auth';

export default {
  name: 'Sync',
  data() {
    return {
      loading: true,
      redirect: undefined,
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    const token = this.getUrlData('token');
    const params = {
      token: token,
    };
    // 登陆
    login_token(params).then((res) => {
      if (res.token) {
        setToken(res.token);
        window.location.href = '/';
      } else {
        location.href = process.env.VUE_APP_ENTRY_URL;
      }
    });
  },
  methods: {
    // 获取uil参数
    getUrlData(data) {
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] === data) {
          return pair[1];
        }
      }
      return false;
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.main {
  width: 100vw;
  height: 100vh;
}
</style>
